export default __webpack_public_path__ + "static/media/screen6.8e4dd68e.png";